import type { CustomField } from '@libs/domain';
import { MstImport, MstImportTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { useCustomFieldBasicSettings } from './hooks';
import { importFunction } from './repositories';
import { createCustomMstItemName } from './services';

function PageComponent({
  customFieldKey,
  ...restProps
}: PageProps & Pick<CustomField['schema'], 'customFieldKey'>) {
  const customFieldSettings = useCustomFieldBasicSettings();

  return (
    <MstImportTmpl
      mstName={createCustomMstItemName(customFieldKey, customFieldSettings)}
      initMstImport={MstImport.baseInit}
      importFunction={importFunction(customFieldKey)()}
      {...restProps}
    />
  );
}

export const Import = withRerender(PageComponent, 'Import');
